/**
 * @generated SignedSource<<978a6349789c14e8535b9dfaa16bde66>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NotificationsCard_brand$data = {
  readonly appConfig: {
    readonly appContent: {
      readonly id: string;
      readonly notificationsOptInSubtitle: string;
      readonly notificationsOptInTitle: string;
    } | null;
    readonly buildTheme: {
      readonly id: string;
      readonly notificationOptInAssetUrl: string | null;
    };
    readonly id: string;
  };
  readonly " $fragmentType": "NotificationsCard_brand";
};
export type NotificationsCard_brand$key = {
  readonly " $data"?: NotificationsCard_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"NotificationsCard_brand">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationsCard_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandAppConfigType",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "BrandAppConfigContentType",
          "kind": "LinkedField",
          "name": "appContent",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "notificationsOptInTitle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "notificationsOptInSubtitle",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BrandAppConfigBuildThemeType",
          "kind": "LinkedField",
          "name": "buildTheme",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "notificationOptInAssetUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};
})();

(node as any).hash = "0e5897e99004abfe5a12b95d28509532";

export default node;
